import { cookieHelper } from './cookieHelper';
import { userHelper } from 'helpers';

interface CustexUser {
    guid?: string;
    emailAddresses?: EmailAddress[];
    phoneNumbers?: PhoneNumber[];
    activated?: boolean;
    auth?: CustexUserAuth;
    contactOptions?: ContactOptions[];
    firstName?: string;
    surname?: string;
}

interface CustexUserAuth {
    username: string;
    password?: string;
}

interface HasPrimary {
    primary: boolean;
}

interface PhoneNumber extends HasPrimary {
    number: string;
}

interface EmailAddress extends HasPrimary {
    address: string;
}

interface ContactOptions {
    contactTypeId: number;
    reason: string;
    source: string;
    email: boolean;
    phone: boolean;
    sms: boolean;
    socialMedia: boolean;
    pushNotification: boolean;
    directMail: boolean;
}

const CUSTOMER_HAS_EXISTING_BASKET_REASON = 'Customer has existing basket';
const CUSTOMER_HAS_EXISTING_FAVOURITES_REASON = 'Customer has existing favourites';
const CONTACT_OPTIONS_SOURCE = 'checkout';

export class CustexHelper {
    public createCustexUser(username: string, password: string, firstName?: string, lastName?: string) {
        /** from old system */
        const custexUser: CustexUser = {};
        const user = userHelper.getUser();

        let userId = user?.userId
            ? user.userId
            : userHelper.getRetailExperienceUser()?.userId;

        if (userId) {
            custexUser.guid = userId;
        }

        if (firstName) {
            custexUser.firstName = firstName;
        }

        if (lastName) {
            custexUser.surname = lastName;
        }

        if (username.includes('@')) {
            // email
            custexUser.emailAddresses = [];
            custexUser.emailAddresses.push({
                address: username,
                primary: true
            });
        } else {
            // phone
            custexUser.phoneNumbers = [];
            custexUser.phoneNumbers.push({
                number: username,
                primary: true
            });
        }

        if (password) {
            custexUser.activated = true;
            custexUser.auth = {
                username: username,
                password: password
            };
        } else {
            custexUser.activated = false;
            custexUser.auth = {
                username: username
            };
        }

        custexUser.contactOptions = [
            {
                contactTypeId: 2,
                reason: CUSTOMER_HAS_EXISTING_BASKET_REASON,
                source: CONTACT_OPTIONS_SOURCE,
                email: true,
                phone: true,
                sms: true,
                socialMedia: true,
                pushNotification: true,
                directMail: true
            },
            {
                contactTypeId: 1,
                reason: CUSTOMER_HAS_EXISTING_BASKET_REASON,
                source: CONTACT_OPTIONS_SOURCE,
                email: false,
                phone: false,
                sms: false,
                socialMedia: false,
                pushNotification: false,
                directMail: false
            },
            {
                contactTypeId: 4,
                reason: CUSTOMER_HAS_EXISTING_BASKET_REASON,
                source: CONTACT_OPTIONS_SOURCE,
                email: false,
                phone: false,
                sms: false,
                socialMedia: false,
                pushNotification: false,
                directMail: false
            },
            {
                contactTypeId: 5,
                reason: CUSTOMER_HAS_EXISTING_BASKET_REASON,
                source: CONTACT_OPTIONS_SOURCE,
                email: false,
                phone: false,
                sms: false,
                socialMedia: false,
                pushNotification: false,
                directMail: false
            }
        ];

        const favourites = cookieHelper.getCookie('rex-favourites');

        if (favourites?.length) {
            custexUser.contactOptions = custexUser.contactOptions.concat(
                [
                    {
                        contactTypeId: 3,
                        reason: CUSTOMER_HAS_EXISTING_FAVOURITES_REASON,
                        source: CONTACT_OPTIONS_SOURCE,
                        email: true,
                        phone: true,
                        sms: true,
                        socialMedia: true,
                        pushNotification: true,
                        directMail: true
                    }
                ]
            );
        } else {
            custexUser.contactOptions = custexUser.contactOptions.concat(
                [
                    {
                        contactTypeId: 3,
                        reason: CUSTOMER_HAS_EXISTING_BASKET_REASON,
                        source: CONTACT_OPTIONS_SOURCE,
                        email: false,
                        phone: false,
                        sms: false,
                        socialMedia: false,
                        pushNotification: false,
                        directMail: false
                    }
                ]
            );
        }

        return custexUser;
    }
}

export const custexHelper = new CustexHelper();